import styles from './style.module.scss'

export const stepsData = [
	['Оставьте заявку ', styles.stepOne],
	['Подпишите документы', styles.stepTwo],
	['Получите деньги и начните спокойную жизнь', styles.stepTree],
]
